import { render } from "./AposContextMenuTip.vue?vue&type=template&id=8a93cd2a"
import script from "./AposContextMenuTip.vue?vue&type=script&setup=true&lang=js"
export * from "./AposContextMenuTip.vue?vue&type=script&setup=true&lang=js"

import "./AposContextMenuTip.vue?vue&type=style&index=0&id=8a93cd2a&lang=scss"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ui/ui/apos/components/AposContextMenuTip.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a93cd2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a93cd2a', __exports__)) {
    api.reload('8a93cd2a', __exports__)
  }
  
  module.hot.accept("./AposContextMenuTip.vue?vue&type=template&id=8a93cd2a", () => {
    api.rerender('8a93cd2a', render)
  })

}


export default __exports__